import { configureStore } from '@reduxjs/toolkit'
import langsliceReducer from './services/lang'

export default configureStore({
  reducer: {
    langs:langsliceReducer
  },
})